module.exports = __webpack_public_path__ + "static/img/elex.99aa3c52.png";